/**
 * SortableHeader — cabeçalho compartilhado para tabelas com ordenação server-side.
 *
 * RELEASE: 2026-09-27 v1.0.0 - Extraído da listagem de Propostas para reuso
 * em listagens premium, sem acoplamento com tipos de um domínio específico.
 */
import { ArrowUpDown, ChevronDown, ChevronUp } from 'lucide-react';
import { TableHead } from '@/components/ui/table';
import { cn } from '@/lib/utils';

interface SortableHeaderProps<TField extends string> {
  label: string;
  field: TField;
  currentField: TField;
  currentDirection: 'asc' | 'desc';
  onSort: (field: TField) => void;
  className?: string;
}

/** Renderiza o rótulo e comunica visualmente a direção aplicada. */
export function SortableHeader<TField extends string>({
  label,
  field,
  currentField,
  currentDirection,
  onSort,
  className,
}: SortableHeaderProps<TField>) {
  return (
    <TableHead
      className={cn('cursor-pointer select-none text-xs font-medium transition-colors hover:bg-muted/30', className)}
      onClick={() => onSort(field)}
      aria-sort={currentField === field ? (currentDirection === 'asc' ? 'ascending' : 'descending') : 'none'}
    >
      <div className="flex items-center gap-1">
        <span>{label}</span>
        {currentField === field ? (
          currentDirection === 'asc' ? <ChevronUp className="h-3 w-3" /> : <ChevronDown className="h-3 w-3" />
        ) : (
          <ArrowUpDown className="h-3 w-3 opacity-30" />
        )}
      </div>
    </TableHead>
  );
}